import { render, staticRenderFns } from "./DocumentCommentNew.vue?vue&type=template&id=dcb9f3f0&"
import script from "./DocumentCommentNew.vue?vue&type=script&lang=js&"
export * from "./DocumentCommentNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports